import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=2e02316d&scoped=true"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e02316d",
  null
  
)

export default component.exports